import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {RouterService} from '@npck/libs/commons';
import {SessionStorageService} from 'ngx-webstorage';
import {AuthHolderService, type Role} from '../domain/auth-holder.service';
import {saveReturnUrl} from '../domain/browser-storage.keys';
import {Path} from '../path';

export const authGuard: CanActivateFn = (_, state): boolean => {
    const authHolderService = inject(AuthHolderService);
    const sessionStorageService = inject(SessionStorageService);
    const routerService = inject(RouterService);
    if (!authHolderService.isTokenExpired()) {
        return true;
    }
    const targetUrl = state.url;
    if (targetUrl && targetUrl !== '/' && !targetUrl.startsWith('/' + Path.LOGIN)) {
        saveReturnUrl(sessionStorageService, targetUrl);
    }
    routerService.navigate(Path.ROOT, {replaceUrl: true});
    return false;
};

function createRoleGuard(roles: Role[], redirectTo: string = Path.INCIDENTS): CanActivateFn {
    return (_, __): boolean => {
        const authHolderService = inject(AuthHolderService);
        const routerService = inject(RouterService);
        if (authHolderService.hasAccess(roles)) {
            return true;
        }
        routerService.navigate(redirectTo);
        return false;
    };
}

export const npckAdminGuard: CanActivateFn = createRoleGuard(['npck-admin'], Path.ROOT);
export const analyticsGuard: CanActivateFn = createRoleGuard(['npck-admin', 'finance-user']);
export const adminPanelGuard: CanActivateFn = createRoleGuard(['npck-admin']);
export const adminPanelUsersGuard: CanActivateFn = createRoleGuard(['npck-admin', 'organization-supervisor']);
export const refundsGuard: CanActivateFn = createRoleGuard(['npck-admin', 'government-user', 'finance-user']);
export const afCentreGuard: CanActivateFn = createRoleGuard(['npck-admin', 'government-user', 'finance-user', 'potential-victim-manager']);
